import { useSite } from "@/context/SiteContext";
import { PageHero } from "@/components/common";
import NowLive from "@/components/NowLive";
import useTitle from "@/lib/useTitle";

export default function Agora() {
  useTitle("Agora na Feira");
  const { data } = useSite();
  return (
    <>
      <PageHero eyebrow="Em tempo real" title="Agora na Feira" tone="#10231a">Atividades em curso e as próximas, de acordo com a hora de Lisboa. Atualiza automaticamente.</PageHero>
      <div className="container-x py-12"><NowLive dark={false} /></div>
      {data.activities.length === 0 && <p className="container-x pb-12">Programação ainda não publicada.</p>}
    </>
  );
}
